import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressDciAccordion extends ResourceItemHtmlProvider {

  constructor(filterServices) {
    super(filterServices);
  }

  getItemHtml(item, relatedMedia) {
    let html = '';

    if (item.Interfaces && item.Interfaces.length){
      const interfaceOrderMap = this.orderInterfaces(item.Interfaces);

      html += `
        <div class="-mb5">
          <div class="-mb2 -fs0">
            <div class="-vam -dib -pr2">
              <img src="${item.Logo[0].Url}" class="-w8"/>
            </div>
            <h5 class="-dib -vam -mb0">${this.encodeHtml(item.Title)}</h5>
          </div>
          <div>
        `;

      interfaceOrderMap.forEach((value, key) => {
        if(key === 'other'){
          for(let otherInterface of value){
            html += this.buildInterfaceHtml(otherInterface);
          }
        }
        else{
          if(value){
            html += this.buildInterfaceHtml(value);
          }
        }
      });
      html += '</div>';
    }
    html += '</div>';

    return html;

  }

  buildInterfaceHtml(interfaceData){
    let html = "";
    const hasResources = interfaceData.BlogPosts || interfaceData.Videos || interfaceData.SuccessStories
          || interfaceData.Tutorials || interfaceData.Webinars || interfaceData.Whitepapers;

    if(hasResources || interfaceData.Documentation){
      html += `<div class="Expandable -mb1">
                <a href="javascript:void(0)" class="Expandable-button -pl2">${this.encodeHtml(interfaceData.InterfaceTitle)}</a>
                <div class="Expandable-content -p2">
                  <div class="row -no-pseudo">`;
      if(interfaceData.Documentation){
        html += `<div class="col-8 -m-full -m-mb0 -no-pseudo col--docs">
                    <h6 class="-lh100 -fw5 -ls0 -mb1">Documentation</h6>`;
        for(let docContent of interfaceData.Documentation.SectionContent){
          html += `<div class="-mb2">${docContent}</div></div>`;
        }
      }

      if(hasResources){
        html += `<div class="col-8 -m-full -m-mb0 -no-pseudo">`;
        if(interfaceData.BlogPosts){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Blogs</h6>`;
          for(let blogPostLink of interfaceData.BlogPosts.Links){
            html += `<div class="-mb2">
                      <a href="/blogs/${blogPostLink.ItemUrl}" class="-db -fs18 -lh130">${blogPostLink.Title}</a>
                    </div>`;
          }
        }

        if(interfaceData.Videos){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Videos</h6>`
          for(let videoLink of interfaceData.Videos.Links){
            html += `<div class="-mb2">
                      <a href="${(videoLink.ItemUrl ? "https://www.youtube.com/watch?v=" + videoLink.ItemUrl : videoLink.CustomUrl)}" class="-db -fs18 -lh130" target="_blank">${this.encodeHtml(videoLink.Title)}</a>
                    </div>`;
          }
        }

        if(interfaceData.SuccessStories){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Success Stories</h6>`;

          for(let successStoryLink of interfaceData.SuccessStories.Links){
            html += `<div class="-mb2">
                      <a href="/customers/${successStoryLink.ItemUrl}" class="-dib -fs18">${this.encodeHtml(successStoryLink.Title)}</a>
                    </div>`;

          }
        }
        html += '</div><div class="col-8 -m-full -m-mb0 -no-pseudo">';

        if(interfaceData.Tutorials){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Tutorials</h6>`;

          for(let tutorialLink of interfaceData.Tutorials.Links){
            html += `<div class="-mb2">
                      <a href="/tutorials/${tutorialLink.ItemUrl}" class="-db -fs18 -lh130">${this.encodeHtml(tutorialLink.Title)}</a>
                    </div>`;
          }
        }

        if(interfaceData.Webinars){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Webinars</h6>`;

          for(let webinarLink of interfaceData.Webinars.Links){
            html += `<div class="-mb2">
                      <a href="${(webinarLink.ItemUrl ? "/webinars/"+ webinarLink.ItemUrl : webinarLink.CustomUrl)}" class="-db -fs18 -lh130">${this.encodeHtml(webinarLink.Title)}</a>
                    </div>`;
          }
        }

        if(interfaceData.Whitepapers){
          html += `<h6 class="-lh100 -fw5 -ls0 -mb1">Papers</h6>`;

          for(let paperLink of interfaceData.Whitepapers.Links){
            html += `<div class="-mb2">
                      <a href="${(paperLink.ItemUrl ? "/papers/" + paperLink.ItemUrl : paperLink.CustomUrl)}" class="-db -fs18 -lh130">${this.encodeHtml(paperLink.Title)}</a>
                    </div>`;
          }
        }

        html += '</div>';
      }
      html += '</div></div></div>';
    }
    return html;
  }

  orderInterfaces(interfacesCollection) {
    const interfaceOrderMap = new Map();
    interfaceOrderMap.set('odbc', null);
    interfaceOrderMap.set('jdbc', null);
    interfaceOrderMap.set('net', null);
    interfaceOrderMap.set('odata', null);
    interfaceOrderMap.set('xml-converters', null);
    interfaceOrderMap.set('xquery', null);
    interfaceOrderMap.set('xml-editor', null);
    interfaceOrderMap.set('other', []);

    for(let currentInterface of interfacesCollection){
      if(interfaceOrderMap.has(currentInterface.InterfaceUrlName)){
        interfaceOrderMap.set(currentInterface.InterfaceUrlName, currentInterface);
      }
      else{
        interfaceOrderMap.get('other').push(currentInterface);
      }
    }

    return interfaceOrderMap;
  }
}
